export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес түрі"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шот түрі"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Атауы"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес жасау"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шот жасау"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жаңа адрес жасау"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жаңа шот жасау"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Атауы енгізіңіз"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валютаны таңдаңыз"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жасау"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Болдырмау"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Түрін таңдаңыз"])}
}